import React, { Component } from "react";
import { connect } from "react-redux";
import { hashHistory, withRouter } from "react-router";
import Util from "../util.js";
import "./detailInformation.css";
import InfoTable from "./InfoTable.js";
import H5Page from "./product/H5page";
class BaseInformationGeneral extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  goVideo = (url) => {
    window.location.href = encodeURI(url/* "https://live.vhall.com/v3/lives/subscribe/981938248" */);
  };

  goBack = () => {
    hashHistory.goBack();
  };
  getMore = () => {
    hashHistory.push({
      pathname: "/PortfolioPerformance",
      state: { superFundCode: this.props.superFundCode },
      query: { superFundCode: this.props.superFundCode },
    });
  };

  getInfo = (incomeRateList = {}) => {
    return [
      [
        [Util.toPercent(incomeRateList.hisAnnualizedGains), "成立以来年化"],
        [Util.toPercent(incomeRateList.maxRetreat), "近一年最大回撤"],
        [Util.toPercent(incomeRateList.dayGains), "日涨跌幅"],
      ],
    ];
  };
  getAll = () => {
    hashHistory.push({
      pathname: "/ServiceReport",
      state: { superFundCode: this.props.superFundCode },
      query: { superFundCode: this.props.superFundCode },
    });
  };
  toRecentNewsDetail = (id) => {
    hashHistory.push({
      pathname: "/ServiceReportDetail",
      state: { id },
      query: { id },
    });
  };
  render() {
    const fundName = this.props.superFundName;
    const { baseInfo, strategy, recentNewsList, operationDay='--', riskLevelName='--', hasOneYear,introVideoUrl} = this.props;
    const infoTable = this.getInfo(baseInfo);
    const recentNewsLists = recentNewsList ? recentNewsList.slice(0, 3) : [];
    const strategyFlag = strategy && strategy.strategy && strategy.strategy.trim();
    const lightPointFlag = strategy && strategy.lightPoint && strategy.lightPoint.trim();
    return (
      <div className="DeInfo_container">
        <div className="DeInfo_strategy_wrap">
          <div className="DeInfo">
            <div className="DeInfo_fundName">
              <div>{fundName}</div>
              {introVideoUrl && hasOneYear && <div onClick={()=>this.goVideo(introVideoUrl)}>视频介绍</div>}
            </div>
            <div className="DeInfo_runtime">
              <span>{riskLevelName}</span>
              <span>{`已运行${operationDay}天`}</span>
            </div>
          </div>

          {hasOneYear && (
            <div>
              <InfoTable cols={3} dataSouse={infoTable} className="InfoTable" />

              <div className="get_more" onClick={this.getMore}>
                查看更多数据
                <img src={require("../img/n_icon_right_arrow.png")} />
              </div>
            </div>
          )}

          {(strategyFlag || lightPointFlag) && (
            <div className="strategy">
              {strategyFlag && (
                <div className="strategy_item">
                  <p className="strategy_item_text">
                    <span>投资策略</span> | {strategy.strategy.trim()}
                  </p>
                </div>
              )}
              {lightPointFlag && (
                <div className="strategy_item">
                  <p className="strategy_item_text">
                    <span>策略亮点</span> | {strategy.lightPoint.trim()}
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
        {introVideoUrl && hasOneYear != undefined && !hasOneYear && (
          <div onClick={()=>this.goVideo(introVideoUrl)} style={{ height: "2.8rem",  marginTop: ".1rem", borderRadius: ".2rem" }}>
            <img style={{ width: "100%" }} src={require("../img/radio_big_bg.jpg")} />
          </div>
        )}
        {!!recentNewsLists.length && (
          <div className="DeInfo_dynameic" >
            <div className="dynameic" onClick={this.getAll}>
              <img src={require("../img/n_icon_dynameic@2x.png")} />

              <div className="query_more" >
                查看全部
                <img src={require("../img/n_icon_right_arrow.png")} />
              </div>
            </div>
            <div className="dynameic_list">
              {recentNewsLists.map((item) => (
                <div
                  key={item.id}
                  className="dynameic_item"
                  onClick={()=>this.toRecentNewsDetail(item.id)}
                >
                  <div>· {item.title}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const {superFund={}, strategy, recentNewsList, superFundBasicInfo = {} } = state.strategiesDetails;
  return {
    baseInfo: state.superFundProductIncomes,
    strategy: strategy,
    recentNewsList: recentNewsList,
    operationDay: superFundBasicInfo.operationDay,
    riskLevelName: superFundBasicInfo.riskLevelName,
    fullOneYear: superFundBasicInfo.fullOneYear,
    hasOneYear: state.superFundProductIncomes.hasOneYear,
    introVideoUrl:superFund.introVideoUrl
  };
}
export default withRouter(connect(mapStateToProps)(BaseInformationGeneral));



// WEBPACK FOOTER //
// ./src/components/BaseInformationGeneral.js